import {useTheme} from '@primer/react'
import {Button, Image, Text} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import Styles from './IdeListItem.module.css'

export const validSizes = ['big', 'medium', 'small'] as const
export const validIds = [
  'github',
  'vscode',
  'vs',
  'xcode',
  'jetbrains',
  'neovim',
  'azuredatastudio',
  'eclipse',
  'raycast',
] as const

export interface IdeListItemProps {
  id: (typeof validIds)[number]
  name: string
  href: string
  image: string | {light: string; dark: string}
  appendix?: string
  onClick?: (ideId: string, ideName: string) => void
  size: (typeof validSizes)[number]
  isListItem?: boolean
}

const defaultProps: Partial<IdeListItemProps> = {}

const IdeListItem = (props: IdeListItemProps) => {
  const initializedProps: IdeListItemProps = {...defaultProps, ...props}
  const {href, id, image, name, appendix, size, isListItem, onClick} = initializedProps

  const {colorScheme} = useTheme()

  const Tag = isListItem ? 'li' : 'div'

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const resolvedColorScheme = colorScheme!
  const imageSrc =
    typeof image === 'string' ? image : ['dark', 'night'].includes(resolvedColorScheme) ? image.dark : image.light

  return (
    <Tag className={clsx(Styles['IdeListItem'], Styles[`IdeListItem--${size}` as keyof typeof Styles])} data-ide={id}>
      <Button
        className={Styles['IdeListItem__button']}
        as="a"
        href={href}
        {...(onClick && {onClick: () => onClick(id, name)})}
      >
        <Image src={imageSrc} alt="" width="70" height="70" />
        <Text as="div" size="100" weight="normal" className={Styles['IdeListItem__button-text']}>
          {name} <span className="sr-only">{appendix}</span>
        </Text>
      </Button>

      <Text as="div" size="100" weight="normal" className={Styles['IdeListItem__subtext']} aria-hidden="true">
        {name} {appendix}
      </Text>
    </Tag>
  )
}

export default IdeListItem
